import step1 from '../assets/1.jpg'
import step2 from '../assets/2.jpg'
import step3 from '../assets/3.jpg'
import step4 from '../assets/4.jpg'
import step5 from '../assets/5.jpg'

export const HOW_IT_WORKS_SECTION = {
  heading: 'How does a Gousto food box subscription work?',
  steps: [
    {
      src: step1,
      alt: 'Step 1: Three-person dinner table with a healthy Gousto recipe, cooked at home.',
      title: '1. Tell us what you need',
      paragraph: 'Choose between 2-5 recipes for 1 to 5 people.',
    },
    {
      src: step2,
      alt: 'Step 2: Customer browsing the Gousto weekly menu to choose recipes for their box.',
      title: '2. Pick the recipes you fancy',
      paragraph: 'Choose from over 175 recipes every week.',
    },
    {
      src: step3,
      alt: 'Step 3: Gousto recipe box delivery at the front door with fresh, pre-portioned ingredients.',
      title: '3. Decide on a delivery day',
      paragraph: 'Get fresh ingredients delivered to your door on a day that suits you.',
    },
    {
      src: step4,
      alt: 'Step 4: Customer enjoying a Health Hub 15-minute Gousto recipe at home.',
      title: '4. Enjoy delicious home-cooked meals',
      paragraph: 'Ready in as little as 10 minutes.',
    },
    {
      src: step5,
      alt: 'Step 5: Gousto app screen showing box management: change frequency, skip or cancel.',
      title: '5. No lock-ins',
      paragraph: 'Skip, pause or cancel whenever you like.',
    },
  ],
  ctaText: 'Get started with 50% off',
}
